import React, { useState, useEffect } from 'react';

const TeacherForm = ({ teacher, onSubmit, onReset }) => {
	const [username, setUsername] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [subject, setSubject] = useState('');
	const [teacherId, setTeacherId] = useState('');
	const [formTitle, setFormTitle] = useState('Create Teacher');

	useEffect(() => {
		if (teacher) {
			setUsername(teacher.username || '');
			setEmail(teacher.email || '');
			setPassword(''); // Don't populate password field for security
			setSubject(teacher.subject || '');
			setTeacherId(teacher.teacher_id || '');
			setFormTitle('Edit Teacher');
		} else {
			setUsername('');
			setEmail('');
			setPassword('');
			setSubject('');
			setTeacherId('');
			setFormTitle('Create Teacher');
		}
	}, [teacher]);

	const handleSubmit = (e) => {
		e.preventDefault();

		const formData = {
			username,
			email,
			subject,
			password: password || undefined, // Only include password if provided
		};

		onSubmit(formData);
	};

	const handleReset = () => {
		setUsername('');
		setEmail('');
		setPassword('');
		setSubject('');
		setTeacherId('');
		setFormTitle('Create Teacher');

		if (onReset) {
			onReset();
		}
	};

	return (
		<form id="teacherForm" onSubmit={handleSubmit}>
			<h5 className="mb-3" id="teacherFormTitle">
				{formTitle}
			</h5>
			<input type="hidden" name="teacher_id" value={teacherId} />

			<div className="form-group">
				<label htmlFor="username">Username:</label>
				<input
					type="text"
					className="form-control"
					id="username"
					name="username"
					value={username}
					onChange={(e) => setUsername(e.target.value)}
					required
				/>
			</div>

			<div className="form-group">
				<label htmlFor="email">Email:</label>
				<input
					type="email"
					className="form-control"
					id="email"
					name="email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					required
				/>
			</div>

			<div className="form-group">
				<label htmlFor="password">Password:</label>
				<input
					type="password"
					className="form-control"
					id="password"
					name="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					required={!teacher} // Only required for new teachers
				/>
			</div>

			<div className="form-group">
				<label htmlFor="subject">Subject:</label>
				<input
					type="text"
					className="form-control"
					id="subject"
					name="subject"
					value={subject}
					onChange={(e) => setSubject(e.target.value)}
				/>
			</div>

			<div className="form-group">
				<button type="submit" className="btn btn-primary">
					Submit
				</button>
				<button
					type="button"
					className="btn btn-outline-primary"
					onClick={handleReset}
				>
					Reset
				</button>
			</div>
		</form>
	);
};

export default TeacherForm;
